import React, { useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import customData from 'Content/contentCustomMakeup.json';
import Context from '../../../context';
import vmContext from '../../context';
import { language } from 'Root/constants';
import MakeupItem from './MakeupItem';
import { ClickLayer } from '../../../../ga4';

export default function MakeupCategory({ children }) {
  const context = useContext(Context);
  const {
    makeupCleared,
    updateMakeup,
    updateMakeupCleared,
    lensCleared,
    makeup,
  } = context;
  const { selectedLensType, lensIndex } = useContext(vmContext);

  const customMakeup = customData.data[language][selectedLensType][lensIndex];
  const { shades, type } = customMakeup[makeup];

  const makeupHandler = (key) => () => {
    updateMakeup(key);
    ClickLayer('JPmakeupClick');

    if (!lensCleared) {
      updateMakeupCleared(false);
    }
  };

  return (
    <Fragment>
      {children(shades, type)}
      <ul className="palette--wrapper palette--wrapper__makeup">
        {customMakeup.map((item, index) => (
          <MakeupItem
            key={`makeup-item-${index}`}
            item={item}
            index={index}
            makeup={makeup}
            makeupHandler={makeupHandler}
            makeupCleared={makeupCleared}
          />
        ))}
      </ul>
    </Fragment>
  );
}

MakeupCategory.propTypes = {
  appLang: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
};
